export default {
    translation: {
        breadcrumbs: {
            '404': '404',
            '500': '500',
            'app': 'אפליקציה',
            'horizontal': 'אופקי',
            'horizontalMenu': 'תפריט אופקי',
            'general': 'כללי',
            'component': 'רְכִיב',
            'features': 'מאפיינים',
            'applications': 'יישומים',
            'dashboard': 'לוח המחוונים',
            'dashboard1': 'לוח מחוונים 1',
            'dashboard2': 'לוח המחוונים 2',
            'dashboard3': 'לוח מחוונים 3',
            'modules': 'מודולים',
            'agency': 'סוֹכְנוּת',
            'pages': 'דפים',
            'gallery': 'גלריה',
            'pricing': 'תמחור',
            'terms&Conditions': 'תנאי תנאים',
            'feedback': 'מָשׁוֹב',
            'report': 'להגיש תלונה',
            'faq(s)': 'שאלות נפוצות ',
            'advancedComponent': 'רכיב מתקדם',
            'blank': 'רֵיק',
            'session': 'מוֹשָׁב',
            'login': 'התחברות',
            'register': 'הירשם',
            'lockScreen': 'מסך נעילה',
            'forgotPassword': 'שכחת את הסיסמא',
            'uiComponents': 'רכיבי ממשק משתמש',
            'alerts': 'התראות',
            'appBar': 'בר יישומים',
            'avatars': 'אווטרים',
            'buttons': 'כפתורים',
            'bottomNavigations': 'ניווט למטה',
            'badges': 'תגים',
            'cards': 'כרטיסים',
            'cardsMasonry': 'כרטיסים מודפסים',
            'chip': 'שְׁבָב',
            'dialog': 'דיאלוג',
            'dividers': 'מְחוּגָה',
            'drawers': 'תַחתוֹנִים',
            'popover': 'פופובר',
            'expansionPanel': 'לוח הרחבה',
            'gridList': 'רשימת רשת',
            'list': 'רשימה',
            'menu': 'תַפרִיט',
            'popoverAndToolTip': 'פופ מעל והסבר קצר',
            'progress': 'התקדמות',
            'snackbar': 'סנקבר',
            'selectionControls': 'פקדי בחירה',
            'advanceUiComponents': 'מתקדם רכיבי ממשק משתמש',
            'dateAndTimePicker': 'תאריך & תאריך בורר',
            'tabs': 'כרטיסיות',
            'stepper': 'צעד',
            'notification': 'הוֹדָעָה',
            'sweetAlert': 'התראה מתוקה',
            'autoComplete': 'השלמה אוטומטית',
            'aboutUs': 'עלינו',
            'widgets': 'ווידג\'טים',
            'forms': 'טפסים',
            'formElements': 'אלמנטים טופס',
            'textField': 'שדה טקסט',
            'selectList': 'בחר רשימה',
            'charts': 'תרשימים',
            'reCharts': 'תרשימים חוזרים',
            'reactChartjs2': 'לְהָגִיב תרשים 2',
            'icons': 'סמלים',
            'themifyIcons': 'לסנכרן סמלים',
            'simpleLineIcons': 'אייקונים פשוטים',
            'materialIcons': 'סמלים חומר',
            'fontAwesome': 'גופן מדהים',
            'tables': 'טבלאות',
            'basic': 'בסיסי',
            'dataTable': 'טבלת נתונים',
            'responsive': 'תגובה',
            'reactTable': 'טבלת תגובה',
            'maps': 'מפות',
            'googleMaps': 'גוגל מפות',
            'leafletMaps': 'מפות עלים',
            'inbox': 'תיבת הדואר הנכנס',
            'users': 'משתמשים',
            'userProfile1': 'פרופיל משתמש 1',
            'userProfile2': 'פרופיל משתמש 2',
            'userManagement': 'ניהול משתמשים',
            'userProfile': 'פרופיל משתמש',
            'userList': 'רשימת משתמש',
            'calendar': 'לוּחַ שָׁנָה',
            'cultures': 'תרבויות',
            'dnd': 'Dnd',
            'selectable': 'ניתן לבחירה',
            'customRendering': 'עיבוד מותאם אישית',
            'chat': 'לְשׂוֹחֵחַ',
            'toDo': 'לעשות',
            'editor': 'עוֹרֵך',
            'wysiwygEditor': 'עורך WYSIWYG',
            'quillEditor': 'עורך',
            'reactAce': 'תגובת אייס',
            'dragAndDrop': 'גרור ושחרר',
            'reactDragula': 'תגובתי',
            'reactDnd': 'לְהָגִיב דנד',
            'blogManagement': 'בלוג ניהול',
            'ecommerce': 'מסחר אלקטרוני',
            'shopList': 'רשימת החנות',
            'shopGrid': 'חנות רשת',
            'invoice': 'חשבונית',
            'multilevel': 'רב',
            'sublevel': 'תת-קרקעי',
            'dateTimePicker': 'תאריך & תאריך בורר',
            'user': 'משתמש',
            'miscellaneous': 'שונות',
            'promo': 'פרומו',
            'gettingStarted': 'מתחילים',
            'shop': 'לִקְנוֹת',
            'cart': 'עֲגָלָה',
            'checkout': 'לבדוק',
            'saas': 'ס.א.ס.',
            'multiLevel': 'מדורג',
            'level1': 'שלב 1',
            'level2': 'שלב 2',
            'boxed': 'מאורגן',
            'news': 'חֲדָשׁוֹת',
            'extensions': 'תוספים',
            'imageCropper': 'תמונה קרופר',
            'videoPlayer': 'נגן וידאו',
            'dropzone': 'איזור נפילה',
            'crm': 'CRM',
            'projects': 'פרויקטים',
            'projectDetail': 'פירוט הפרויקט',
            'clients': 'לקוחות',
            'reports': 'דיווחים'
        },
        'widgets': {
            'totalEarns': 'סך כל הרווחים',
            'emailsStatistics': 'הודעות דוא ל לסטטיסטיקה',
            'totalRevenue': 'סך הרווחים',
            'onlineVistors': 'באינטרנט מבקרים',
            'trafficSources': 'מקורות תנועה',
            'RecentOrders': 'הזמנות אחרונות',
            'topSellings': 'Tמכירת אופ',
            'productReports': 'דוחות מוצרים',
            'productStats': 'נתונים סטטיסטיים של מוצרים',
            'ComposeEmail': 'כתוב מייל אלקטרוני',
            'employeePayroll': 'שכר שכר',
            'visitors': 'מבקרים',
            'orders': 'הזמנות',
            'totalSales': 'סה"כ מכירות',
            'orderStatus': 'מצב הזמנה',
            'netProfit': 'נֶטוֹ רווח',
            'overallTrafficStatus': 'מצב התנועה הכולל',
            'ratings': 'דירוגים',
            'tax': 'מַס',
            'expenses': 'הוצאות',
            'currentTime': 'זמן נוכחי',
            'currentDate': 'דייט נוכחי',
            'todayOrders': 'הזמנות היום',
            'toDoList': 'לעשות רשימות',
            'discoverPeople': 'גלה אנשים',
            'commments': 'הערות',
            'newCustomers': 'לקוחות חדשים',
            'recentNotifications': 'הודעות אחרונות',
            'appNotifications': 'התראות יישום',
            'siteVisitors': '',
            'recentActivities': 'פעילויות אחרונות',
            'recentOrders': 'הזמנות אחרונות',
            'gallery': 'גלריה',
            'pricing': 'תמחור',
            'enterpriseEdition': 'גרסה לארגונים',
            'socialCompanines': 'חברות חברתיות',
            'personalEdition': 'מהדורה אישית',
            'teamEdition': 'מהדורת צוות',
            'standard': 'תֶקֶן',
            'advanced': 'מִתקַדֵם',
            'master': 'לִשְׁלוֹט',
            'Mega': 'מגה',
            'logIn': 'התחברn',
            'signUp': 'הירשם',
            'lockScreen': 'מסך נעילה',
            'alertsWithLink': 'התראות עם קישור',
            'additionalContent': 'תוכן נוסף',
            'alertDismiss': 'התראה דחה',
            'uncontrolledDisableAlerts': 'בלתי מבוקרת השבת התראות',
            'contexualAlerts': 'התראות דו - צדדיות',
            'alertsWithIcons': 'התראות עם סמלים',
            'Simple App Bars': 'פשוט ברים אפליקציה',
            'appBarsWithButtons': 'ברים אפליקציה עם לחצנים',
            'imageAvatars': 'תמונה אווטרים',
            'lettersAvatars': 'מכתבים אווטרים',
            'iconsAvatars': 'סמלים אווטרים',
            'flatButtons': 'לחצנים שטוחים',
            'raisedButton': 'לחצן גויס',
            'buttonWithIconAndLabel': 'לחצן עם סמל ותווית',
            'floatingActionButtons': 'לחצני פעולה צפים',
            'iconButton': 'לחצן סמל',
            'socialMediaButton': 'לחצן מדיה חברתית',
            'reactButton': 'לחצן לְהָגִיב',
            'buttonOutline': 'מתאר',
            'buttonSize': 'גודל כפתור',
            'buttonState': 'מצב לחצן',
            'buttonNavigationWithNoLabel': 'כפתור ניווט ללא תווית',
            'buttonNavigation': 'ניווט באמצעות לחצן',
            'iconNavigation': 'ניווט בסמל',
            'badgeWithHeadings': 'תג עם כותרות',
            'contexualVariations': 'וריאציות מידיות',
            'badgeLinks': 'קישורים \'קישורים\'',
            'materialBadge': 'תג חומר',
            'simpleCards': 'כרטיסים פשוטים',
            'backgroundVarient': 'רקע וריאנט',
            'cardOutline': 'מתווה כרטיס',
            'overlayCard': 'כרטיס כיסוי',
            'cardGroup': 'קבוצת כרטיס',
            'cardTitle': 'כותרת כרטיס',
            'speacialTitleTreatment': 'טיפול כותרת כותרת',
            'chipWithClickEvent': 'צ\'יפ עם אירוע לחץ',
            'chipArray': 'מערך שבבים',
            'dialogs': 'דיאלוגים',
            'listDividers': 'רשימת מחיצות',
            'insetDividers': 'מחלקים',
            'temporaryDrawers': 'מגירות זמניות',
            'permanentDrawers': 'מגירות קבועות',
            'simpleExpansionPanel': 'לוח הרחבה פשוט',
            'controlledAccordion': 'אקורדיון מבוקר',
            'secondaryHeadingAndColumns': 'כותרת משנית ועמודות',
            'imageOnlyGridLists': 'תמונה בלבד רשימות רשת',
            'advancedGridLists': 'רשימות רשת מתקדמות',
            'singleLineGridLists': 'רשימות רשת',
            'simpleLists': 'רשימות פשוטות',
            'folderLists': 'רשימות תיקיות',
            'listItemWithImage': 'פריט רשימה עם תמונה',
            'switchLists': 'החלף רשימות',
            'insetLists': 'רשימות הבלעה',
            'nestedLists': 'רשימות מקוננות',
            'checkboxListControl': 'בקרת רשימת תיבות',
            'pinedSubHeader': 'כותרת משנה',
            'InteractiveLists': '',
            'simpleMenus': 'תפריטים פשוטים',
            'selectedMenu': 'תפריט נבחר',
            'maxHeightMenu': 'תפריט גובה מקסימלי',
            'changeTransition': 'שינוי מעבר',
            'paper': 'עיתון',
            'anchorPlayGround': 'עוגן',
            'tooltip': 'הסבר קצר',
            'positionedToolTips': 'מיקום סנקבר',
            'circularProgressBottomStart': 'התקדמות מעגלית',
            'interactiveIntegration': 'אינטגרציה אינטראקטיבית',
            'determinate': 'קבעו',
            'linearProgressLineBar': 'שורת התקדמות קו לינארי',
            'indeterminate': 'לֹא קָבוּעַ',
            'buffer': 'בַּלָם',
            'query': 'שאילתא',
            'transitionControlDirection': 'כיוון בקרת מעבר',
            'simpleSnackbar': 'פשוט חטיף',
            'positionedSnackbar': 'מיקום סנקבר',
            'contexualColoredSnackbars': 'צבעוני חטיפים צבעוניים',
            'simpleCheckbox': 'תיבת סימון פשוטה',
            'interminateSelection': 'בחירה סופית',
            'disabledCheckbox': 'תיבת סימון מושבתת',
            'customColorCheckbox': 'תיבת צבע מותאמת אישית',
            'VerticalStyleCheckbox': 'תיבת סימון בסגנון אנכי',
            'horizontalStyleCheckbox': 'סגנון אופקי תיבת סימון',
            'radioButtons': 'כפתורי רדיו',
            'disabledRadio': 'רדיו מושבת',
            'withError': 'עם שגיאה',
            'switches': 'Swiches',
            'dateAndTimePicker': 'תאריך ושעה פיקר',
            'defaultPicker': 'בורר ברירת המחדל',
            'timePicker': 'בורר זמן',
            'weekPicker': 'בורר השבוע',
            'defaultDatePicker': 'בְּרִירַת מֶחדָל תַאֲרִיך קוֹטֵף',
            'customPicker': 'בוחר מותאם אישית',
            'tabs': 'כרטיסיות',
            'fixedTabs': 'כרטיסיות קבועות',
            'basicTab': 'הכרטיסייה הבסיסית',
            'wrappedLabels': 'תוויות עטופות',
            'centeredLabels': 'תוויות מרוכזות',
            'forcedScrolledButtons': 'לחצן גלילה כפויs',
            'iconsTabs': 'כרטיסיות סמלים',
            'withDisableTabs': 'עם השבת כרטיסיות',
            'iconWithLabel': 'סמל עם תווית',
            'stepper': 'צעד',
            'horizontalLinear': 'אופקי ליניארי',
            'horizontalNonLinear': 'אופקי לא ליניארי',
            'horizontalLinerAlternativeLabel': 'אופקי ליינר אלטרנטיבי תווית',
            'horizontalNonLinerAlternativeLabel': 'אופקי לא ליינר תווית אלטרנטיבית',
            'verticalStepper': 'סטפר אנכי',
            'descriptionAlert': 'תיאור התראה',
            'customIconAlert': 'התראה סמל מותאם אישית',
            'withHtmlAlert': 'עם התראת HTML',
            'promptAlert': 'התראה מוקדמת',
            'passwordPromptAlert': 'התראת בקשה לסיסמה',
            'customStyleAlert': 'התראה בסגנון מותאם אישית',
            'autoComplete': 'השלמה אוטומטית',
            'reactSelect': 'לְהָגִיב בחר',
            'downshiftAutoComplete': 'השלם אוטומטי',
            'reactAutoSuggests': 'לְהָגִיב אוטומטי מציע',
            'aboutUs': 'עלינו',
            'ourVission': 'שלנו אשר',
            'ourMissions': 'המשימות שלנו',
            'ourMotivation': 'המוטיבציה שלנו',
            'defualtReactForm': 'טופס תגובה ברירת המחדל',
            'url': 'כתובת אתר',
            'textArea': 'אזור טקסט',
            'file': 'קוֹבֶץ',
            'formGrid': 'טופס טבלה',
            'inlineForm': 'טופס מוטבע',
            'inputSizing': 'גודל קלט',
            'inputGridSizing': 'קלט שינוי גודל הרשת',
            'hiddenLabels': 'תוויות נסתרות',
            'formValidation': 'אימות טופס',
            'number': 'מספר',
            'date': 'תַאֲרִיך',
            'time': 'זְמַן',
            'color': 'צֶבַע',
            'search': 'לחפש',
            'selectMultiple': 'בחר מרובים',
            'inputWithSuccess': 'קלט עם הצלחה',
            'inputWithDanger': 'כניסה עם סכנה',
            'simpleTextField': 'שדה טקסט פשוט',
            'componet': 'רכיבים',
            'layouts': 'פריסות',
            'inputAdorements': 'הקלט',
            'formattedInputs': 'תשומות מעוצבות',
            'simpleSelect': 'בחר פשוט',
            'nativeSelect': 'בחירת שפת אם',
            'MutltiSelectList': 'רַב בחר רשימה',
            'lineChart': 'תרשים שורה',
            'barChart': 'טבלת עמודות',
            'stackedBarChart': 'תרשים עמודות מוערמות',
            'lineBarAreaChart': 'תרשים הקו של הקו בר',
            'areaChart': 'תרשים שטח',
            'stackedAreaChart': 'תרשים שטח מוערם',
            'verticalChart': 'תרשים אנכי',
            'radarChart': 'תרשים מכ ם',
            'doughnut': 'סופגניה',
            'polarChart': 'תרשים פולאר',
            'pieChart': 'תרשים עוגה',
            'bubbleChart': 'תרשים הבועה',
            'horizontalBar': 'בר אופק',
            'basicTable': 'טבלה בסיסית',
            'contexualColoredTable': 'טבלה צבעונית',
            'dataTable': 'טבלת נתונים',
            'employeeList': 'רשימת עובדים',
            'responsiveTable': 'טבלאות תגובה',
            'responsiveFlipTable': 'טבלת תגובה לְהַעִיף',
            'reactGridControlledStateMode': 'לְהָגִיב במצב מצב מבוקר',
            'googleMaps': 'גוגל מפות',
            'productsReports': 'דוחות מוצרים',
            'taskList': 'רשימת מטלות',
            'basicCalender': 'בסיסי קלנדר',
            'culturesCalender': 'תרבויות',
            'dragAndDropCalender': 'גרור ושחרר קלנדר',
            'selectableCalender': 'לבחירה קלנדר',
            'customRendering': 'עיבוד מותאם אישית',
            'customCalender': 'לוח שנה מותאם אישית',
            'searchMailList': 'חפש רשימת דואר',
            'forgetPassword': 'שכחתי את הסיסמה',
            'QuickLinks': 'קישורים מהירים',
            'upgrade': 'לשדרג',
            'app': 'App',
            'addNew': 'הוסף חדש',
            'orderDate': 'תאריך הזמנה',
            'status': 'סטָטוּס',
            'trackingNumber': 'Tמספר מרתיעה',
            'action': 'פעולה',
            'designation': 'יִעוּד',
            'subject': 'נושא',
            'send': 'לִשְׁלוֹחַ',
            'saveAsDrafts': 'שמירה כטיוטות',
            'onlineSources': 'מקורות מקוונים',
            'lastMonth': 'חודש שעבר',
            'widgets': 'ווידג\'טים',
            'listing': 'מודעה',
            'paid': 'בתשלום',
            'refunded': 'החזר כספי',
            'done': 'בוצע',
            'pending': 'ממתין ל',
            'cancelled': 'מבוטל',
            'approve': 'לְאַשֵׁר',
            'following': 'הבא',
            'follow': 'לעקוב אחר',
            'graphs&Charts': 'גרפים ותרשימים',
            'open': 'לִפְתוֹחַ',
            'bounced': 'ניתק',
            'spam': 'ספאם',
            'unset': 'לא הוגדר',
            'bandwidthUse': 'שימוש ברוחב פס',
            'dataUse': 'שימוש בנתונים',
            'unsubscribe': 'בטל רישום',
            'profile': 'פּרוֹפִיל',
            'messages': 'הודעות',
            'support': 'תמיכה',
            'faq(s)': 'פאק (ים)',
            'upgradePlains': 'שדרג שפלים',
            'logOut': 'להתנתק',
            'mail': 'דוֹאַר',
            'adminTheme': 'נושאים של מנהל מערכת',
            'wordpressTheme': 'נושאים',
            'addToCart': 'הוסף לעגלה',
            'plan': 'לְתַכְנֵן',
            'basic': 'בסיסי',
            'pro': 'מִקצוֹעָן',
            'startToBasic': 'התחל בסיסיים',
            'upgradeToPro': 'שדרוג לפרו',
            'upgradeToAdvance': 'שדרג מראש',
            'comparePlans': 'השווה תוכניות',
            'free': 'חופשי',
            'frequentlyAskedQuestions': 'שאלות נפוצות',
            'newEmails': 'הודעות דוא"ל חדשות',
            'searchIdeas': 'חיפוש רעיונות',
            'startDate': 'תאריך התחלה',
            'endDate': 'תאריך סיום',
            'category': 'קטגוריה',
            'apply': 'להגיש מועמדות',
            'downloadPdfReport': 'הורד דוח PDF',
            'yesterday': 'אתמול',
            'totalOrders': 'סהכ הזמנות',
            'totalVisitors': 'סהכ מבקרים',
            'typeYourQuestions': 'הקלד את השאלות שלך',
            'username': 'שם משתמש',
            'password': 'סיסמה',
            'signIn': 'היכנס',
            'enterYourPassword': 'הכנס את הסיסמה שלך',
            'alreadyHavingAccountLogin': 'כבר יש לך כניסה לחשבון',
            'composeMail': 'כתוב דואר',
            'issue': 'נושא',
            'recentChat': 'צ\'אט אחרונים',
            'previousChat': 'צ\'אט הקודם',
            'all': 'את כל',
            'filters': 'מסננים',
            'deleted': 'נמחק',
            'starred': 'כיכב',
            'frontend': 'חזיתי',
            'backend': 'Backend',
            'api': 'Api',
            'simpleAppBar': 'פשוט אפליקציה בר',
            'recents': 'דוכנים',
            'cardLink': 'קישור כרטיס',
            'anotherLink': 'קישור נוסף',
            'cardSubtitle': 'כרטיס',
            'confirmationDialogs': 'דיאלוגים לאישור',
            'deletableChip': 'שבב נמחק',
            'customDeleteIconChip': 'מחיקת סמל',
            'openAlertDialog': 'פתח את תיבת הדו-שיח התראה',
            'openResponsiveDialog': 'פתח את תיבת הדו-שיח \'תגובה\'',
            'openSimpleDialog': 'פתח דיאלוג פשוט',
            'openFormDialog': 'פתח את תיבת הדו-שיח \'טופס\'',
            'follower': 'חָסִיד',
            'important': 'חָשׁוּב',
            'private': 'פְּרָטִי',
            'openLeft': 'פתח שמאלה',
            'openRight': 'פתח את \'ימין\'',
            'openTop': 'פתח את הדף',
            'openBottom': 'פתח את תחתית',
            'selectTripDestination': 'בחר יעד נסיעה',
            'pinnedSubheaderList': 'רשימת כותרות משנה מוצמדות',
            'singleLineItem': 'פריט יחיד',
            'acceptTerms': 'קבל תנאים',
            'optionA': 'אפשרות א',
            'optionB': 'אפשרות ב \'',
            'optionC': 'אפשרות ג',
            'optionM': 'אפשרות M',
            'optionN': 'אפשרות N',
            'optionO': 'אפשרות O',
            'customColor': 'צבע מותאם אישית',
            'centeredTabs': 'כרטיסיות מרוכזות',
            'multipleTabs': 'כרטיסיות מרובות',
            'preventScrolledButtons': 'מנע לחצני גלילה',
            'browse': 'לְדַפדֵף',
            'formValidate': 'טופס אימות',
            'code': 'קוד',
            'company': 'חֶברָה',
            'price': 'מחיר',
            'change': 'שינוי',
            'high': 'גָבוֹהַ',
            'low': 'נָמוּך',
            'volume': 'כרך',
            'personalDetails': 'פרטים אישיים',
            'occupation': 'כיבוש',
            'companyName': 'שם החברה',
            'phoneNo': 'בטלפון',
            'city': 'עִיר',
            'zipCode': 'מיקוד',
            'updateProfile': 'עדכן פרופיל',
            'reject': 'לִדחוֹת',
            'exportToExcel': 'יצוא ל - לְהִצטַיֵן',
            'addNewUser': 'הוסף משתמש חדש',
            'workWeek': 'שבוע עבודה',
            'agenda': 'סֵדֶר הַיוֹם',
            'conference': 'וְעִידָה',
            'multilevel': 'רב',
            'dailySales': 'מכירות יומיות',
            'today': 'היום',
            'campaignPerformance': 'ביצועי מסע פרסום',
            'supportRequest': 'בקשת תמיכה',
            'usersList': 'רשימת משתמשים',
            'lastWeek': 'שבוע שעבר',
            'buyMore': 'קנה עוד',
            'trafficChannel': 'ערוץ תעבורה',
            'stockExchange': 'הבורסה',
            'tweets': 'Tweets',
            'ourLocations': 'המיקומים שלנו',
            'sales': 'מכירה',
            'to': 'To',
            'shipTo': 'משלוח אל',
            'description': 'תיאור',
            'unitPrice': 'מחיר היחידה',
            'total': 'סה"כ',
            'note': 'הערה',
            'chipWithAvatar': 'צ\'יפ עם אווטר',
            'chipWithTextAvatar': 'צ\'יפ עם אווטר טקסט',
            'chipWithIconAvatar': 'צ\'יפ עם סמל גלגול',
            'customClickableChip': 'צ\'יפ הניתן ללחיצה אישית',
            'outlineChip': 'צ\'יפ מתאר',
            'disableChip': 'השבת צ\'יפ',
            'alertDialog': 'התראת דיאלוג',
            'animatedSlideDialogs': 'דיאלוגים שקופיות מונפשים',
            'fullScreenDialogs': 'תיבות דו-שיח למסך מלא',
            'formDialogs': 'טופס דיאלוגים',
            'simpleDialogs': 'דיאלוגים פשוטים',
            'responsiveFullScreen': 'מסך מלא תגובה',
            'primary': 'ראשי',
            'social': 'חברתי',
            'user': 'משתמש',
            'admin': 'מנהל מערכת',
            'permanentdrawer': 'מגירה קבועה',
            'persistentdrawer': 'מגירה מתמדת',
            'swiches': 'Swiches',
            'horizontalLinearAlternativeLabel': 'תווית אלטרנטיבית ליניארית אופקית',
            'horizontalNonLinearAlternativeLabel': 'אופקי לא ליניארי תווית אלטרנטיבית',
            'notifications': 'הודעות',
            'basicAlert': 'התראה בסיסית',
            'successAlert': 'התראה הצלחה',
            'warningAlert': 'התראת אזהרה',
            'reactAutoSuggest': 'תגובה אוטומטית',
            'components': 'רכיבים',
            'inputAdornments': 'הקלט',
            'multiSelectList': 'רשימת רב',
            'contextualColoredTable': 'טבלת צבעים צבעוניים',
            'updateYourEmailAddress': 'עדכן את כתובת הדואר האלקטרוני שלך',
            'selectADefaultAddress': 'בחר כתובת ברירת מחדל',
            'activity': 'פעילות',
            'basicCalendar': 'לוח שנה בסיסי',
            'culturesCalendar': 'תרבויות לוח שנה',
            'dragAndDropCalendar': 'גרור ושחרר את לוח השנה',
            'quillEditor': 'עורך קוויל',
            'reactDND': 'תגובה dnd',
            'dragula': 'דראגולה',
            'AcceptorrRejectWithin': 'קבל או דחה בתוך',
            'quoteOfTheDay': 'ציטוט היום',
            'updated10Minago': 'עודכן לפני 10 דקות',
            'personalSchedule': 'לוח זמנים אישי',
            'activeUsers': 'משתמשים פעילים',
            'totalRequest': 'סה"כ בקשה',
            'new': 'חָדָשׁ',
            'ShareWithFriends': 'לשתף עם חברים!',
            'helpToShareText': 'עזור לנו להפיץ את העולם על ידי שיתוף האתר שלנו עם חברים וחברים שלך על מדיה חברתית!',
            'thisWeek': 'השבוע',
            'howWouldYouRateUs': 'איך היית מדרג אותנו?',
            'booking': 'הזמנה',
            'confirmed': 'מְאוּשָׁר',
            'monthly': 'חודשי',
            'weekly': 'שבועי',
            'target': 'יעד',
            'totalActiveUsers': 'סה"כ משתמשים פעילים',
            'deadline': 'מועד אחרון',
            'team': 'קְבוּצָה',
            'projectManagement': 'ניהול פרוייקט',
            'latestPost': 'הפרסום האחרון',
            'projectTaskManagement': 'ניהול משימות פרוייקט',
            'selectProject': 'בחר פרויקט',
            'activityBoard': 'לוח פעילות',
            'checklist': 'צ\'ק ליסט',
            'baseConfig': 'תצורת Base',
            'customControlBar': 'סרגל בקרה מותאם אישית',
            'withDownloadButton': 'עם לחצן הורדה',
            'httpLiveStreaming': 'HTTP הזרמת חי',
            'keyboardShortcuts': 'קיצורי דרך במקלדת',
            'preview': 'תצוגה מקדימה',
            'croppedImage': 'תמונה חתוכה',
            'transactionList': 'רשימת עסקאות',
            'transferReport': '- דוח העברה',
            'expenseCategory': '- הוצאה',
            'upcomingEvents': 'אירועים קרובים',
            'OngoingProjects': 'פרויקטים מתמשכים',
            'ProjectStatus': 'מצב הפרויקט',
            'LiveChatSupport': 'תמיכה בצ\'אט חי'
        },
        'components': {
            'buyNow': 'קנה עכשיו',
            'alreadyHavingAccountSignIn': 'כבר יש לך חשבון כניסה',
            'enterYourPassword': 'הכנס את הסיסמה שלך',
            'unlock': 'לבטל נעילה',
            'enterPasswords': 'הזן סיסמאות',
            'resetPassword': 'Resest סיסמה',
            'pageNotfound': 'דף לא',
            'sorryServerGoesWrong': 'שרת מצטער טועה',
            'persistentDrawer': 'מגירה מתמשכת',
            'back': 'חזור',
            'next': 'הַבָּא',
            'completeStep': 'שלב שלם',
            'success': 'הַצלָחָה',
            'passwordPrompt': 'בקשה לסיסמה',
            'warning': 'אַזהָרָה',
            'customIcon': 'סמל מותאם אישית',
            'customStyle': 'סגנון מותאם אישית',
            'basic': 'בסיסי',
            'submit': 'שלח',
            'compose': 'לְהַלחִין',
            'sendMessage': 'לשלוח הודעה',
            'addNewTasks': 'הוסף משימות חדשות',
            'addToCart': 'הוסף לעגלה',
            'payNow': 'שלם עכשיו',
            'print': 'הדפס',
            'cart': 'עֲגָלָה',
            'viewCart': 'צפה בסל',
            'checkout': 'לבדוק',
            'summary': 'סיכום',
            'yesterday': 'אתמול',
            'last7Days': 'שבעת הימים האחרונים',
            'last1Month': '1 חודש אחרון',
            'last6Month': 'האחרון 6 חודש',
            'spaceUsed': 'שטח המשמש',
            'followers': 'עוקב',
            'trending': 'מגמות',
            'paid': 'שילם',
            'refunded': 'החזר כספי',
            'done': 'בוצע',
            'pending': 'בהמתנה',
            'cancelled': 'בוטל',
            'approve': 'אשר',
            'week': 'שבוע',
            'month': 'חודש',
            'year': 'שנה',
            'today': 'היום',
            'popularity': 'פופולריות',
            'email': 'אֶלֶקטרוֹנִי',
            'drafts': '',
            'sent': 'נשלח',
            'trash': 'אשפה',
            'all': 'את כל',
            'do': 'עשה',
            'title': 'כותרת',
            'projectName': 'שם הפרויקט',
            'openAlert': 'פתח התראה',
            'slideInAlertDialog': 'שקופית בדיאלוג התראה',
            'openFullScreenDialog': 'פתיחת תיבות דו-שיח מסך מלא',
            'basicChip': 'שבב בסיסי',
            'clickableChip': 'צ\'יפ ללחיצה',
            'left': 'שמאל',
            'right': 'נכון',
            'expansionPanel1': 'לוח הרחבה 1',
            'expansionPanel2': 'לוח הרחבה 2',
            'advancedSettings': 'הגדרות מתקדמות',
            'occupation': 'עיסוק',
            'address': 'כתובת',
            'city': 'עיר',
            'state': 'מדינה',
            'social Connection': 'חיבור חברתי',
            'emailPrefrences': 'העדפות דוא"ל',
            'myProfile': 'הפרופיל שלי',
            'product': 'מוצר',
            'quantity': 'כַּמוּת',
            'totalPrice': 'מחיר סופי',
            'removeProduct': 'הסר מוצר',
            'mobileNumber': 'מספר טלפון נייד',
            'address2Optional': 'כתובת 2 (אופציונלי)',
            'country': 'מדינה',
            'zip': 'רוכסן',
            'saveContinue': 'שמור המשך',
            'placeOrder': 'בצע הזמנה',
            'payment': 'תַשְׁלוּם',
            'billingAddress': 'כתובת לחיוב',
            'ShippingAddressText': 'כתובת המשלוח זהה לכתובת לחיוב.',
            'CartEmptyText': 'עגלת הקניות שלך ריקה!',
            'NoItemFound': 'לא נמצא פריט',
            'goToShop': 'לך לחנות',
            'cardNumber': 'מספר כרטיס',
            'expiryDate': 'תאריך תפוגה',
            'cvv': 'CVV',
            'nameOnCard': 'שם על כרטיס',
            'confirmPayment': 'אשר תשלום'
        },
        'compenets': {
            'choose': 'בחר',
            'username': 'שם משתמש',
            'passwords': 'סיסמאות',
            'signIn': 'היכנס',
            'dontHaveAccountSignUp': 'אין כניסה לחשבון',
            'enterUserName': 'הכנס שם משתמש',
            'enterEmailAddress': 'הזן כתובת דואל',
            'confirmPasswords': 'אשר סיסמאות'
        },
        'themeOptions': {
            'sidebarOverlay': 'כיסוי שכבה צדדית',
            'sidebarBackgroundImages': 'תמונות רקע בסרגל הצד',
            'sidebarImage': 'תמונה של סרגל צדדי',
            'miniSidebar': 'מיני הסרגל הצידי',
            'boxLayout': 'פריסת תיבה',
            'rtlLayout': 'פריסת Rtl',
            'darkMode': 'מצב כהה',
            'appSettings': 'הגדרות אפליקציה',
            'sidebarLight': 'אוֹר',
            'sidebarDark': 'אפל',
            'themeColor': 'צבע ערכת נושא'
        },
        'button': {
            'cancel': 'לְבַטֵל',
            'add': 'לְהוֹסִיף',
            'update': 'עדכון',
            'reply': 'תשובה',
            'delete': 'לִמְחוֹק',
            'yes': 'כן',
            'viewAll': 'צפה בהכל',
            'like': 'כמו',
            'assignNow': 'הקצה עכשיו',
            'seeInsights': 'ראה תובנות',
            'acceptTerms': 'קבל תנאים',
            'reject': 'לִדחוֹת',
            'addNew': 'הוסף חדש',
            'goToCampaign': 'עבור אל מסע פרסום',
            'viewProfile': 'צפה בפרופיל',
            'sendMessage': 'לשלוח הודעה',
            'saveNow': 'שמור עכשיו',
            'pen': 'עֵט',
            'search': 'לחפש',
            'downloadPdfReport': 'הורד דוח PDF',
            'primary': 'יְסוֹדִי',
            'secondary': 'מִשׁנִי',
            'danger': 'סַכָּנָה',
            'info': 'מידע',
            'success': 'הַצלָחָה',
            'warning': 'אַזהָרָה',
            'link': 'קישור',
            'smallButton': 'כפתור קטן',
            'largeButton': 'כפתור גדול',
            'blockLevelButton': 'לחצן רמת בלוק',
            'primaryButton': 'לחצן ראשי',
            'button': 'לַחְצָן',
            'save': 'להציל',
            'openMenu': 'פתח תפריט',
            'openWithFadeTransition': 'פתח עם מעבר לדעוך',
            'openPopover': 'פתח את פופובר',
            'accept': 'לְקַבֵּל',
            'click': 'נְקִישָׁה',
            'complete': 'לְהַשְׁלִים',
            'back': 'חזור',
            'next': 'הַבָּא',
            'completeStep': 'שלב שלם',
            'error': 'שְׁגִיאָה',
            'writeNewMessage': 'כתוב הודעה חדשה',
            'saveChanges': 'שמור שינויים',
            'addNewUser': 'הוסף משתמש חדש',
            'more': 'יותר',
            'useDefaultImage': 'השתמש בתמונת ברירת מחדל',
            'cropImage': 'חתוך תמונה'
        },
        'hint': {
            'whatAreYouLookingFor': 'מה אתה מחפש',
            'searchMailList': 'חפש רשימת דואר'
        },
        'module': {
            'inbox': 'תיבת הדואר הנכנס',
            'drafts': '',
            'sent': 'נשלח',
            'trash': 'אשפה',
            'spam': 'ספאם',
            'frontend': 'חזיתי',
            'backend': 'Backend',
            'api': 'Api',
            'issue': 'נושא'
        },
        'documents': {},
        'common': {},
        'logout': {},
        'login': {},
        'actions': {},
        'sign_up': {},
        'names': {
            'companyName': 'שם החברה',
            'firstName': 'שם פרטי',
            'lastName': 'שם משפחה'
        },
        'settings': {
            'generalSetting': 'הגדרה כללית'
        },
        'phones': {
            'phoneNo': 'טלפון לא'
        },
        'code': {
            'zip קוד': 'מיקוד'
        }
    }
};
